export interface NotificationState {
  notifications: Notification[];
}

export interface Notification {
  type: NotificationType;
  status: NotificationStatus;
  message: string | React.ReactNode;
  canClose?: boolean;
}

export const NotificationType = {
  ALERT: 'alert',
  NOTICE: 'notice',
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export const NotificationStatus = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
} as const;
export type NotificationStatus = (typeof NotificationStatus)[keyof typeof NotificationStatus];
